import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable, inject} from '@angular/core';
import {
    DEFAULT_PAGE_EVENT,
    DEFUALT_SEARCH,
    IEntity,
    IEntityActivate,
    IEntityCreate,
    IEntityCreated,
    IEntityDropDown,
    IPagedData,
    IPagedSearch,
    mongoQueryParser,
} from '@evencel/models';
import {Observable, map} from 'rxjs';
import {EntityQuery} from '../../modules/admin/center-administraion/entity/entity-filter.type';

export const ENTITY_URL = 'entities';

@Injectable({providedIn: 'root'})
export class EntityService {
    httpClient = inject(HttpClient);

    post(data: IEntityCreate): Observable<IEntity> {
        return this.httpClient.post<IEntity>(ENTITY_URL, data);
    }

    patch(data: IEntity): Observable<IEntity> {
        const url = `${ENTITY_URL}/${data._id}`;
        return this.httpClient.patch<IEntity>(url, data);
    }

    activate(data: IEntityActivate): Observable<IEntity> {
        const {active} = data;
        const url = `${ENTITY_URL}/${data._id}/activate`;
        return this.httpClient.patch<IEntity>(url, {active});
    }

    delete(id: string): Observable<void> {
        return this.httpClient.delete<void>(`${ENTITY_URL}/${id}`);
    }

    restore(id: string): Observable<void> {
        return this.httpClient.delete<void>(`${ENTITY_URL}/${id}/restore`);
    }

    searchByQuery(query: Record<string, unknown>, projection = 'select') {
        const condition = mongoQueryParser.parse(query);
        return this.search({
            ...DEFUALT_SEARCH,
            page: {...DEFAULT_PAGE_EVENT, pageSize: 100},
            condition,
            projection,
        });
    }

    searchByField(query: EntityQuery, projection = 'select') {
        return this.searchByQuery({[query]: {$eq: true}}, projection).pipe(map(d => d.data));
    }

    searchByFieldAndName(query: EntityQuery, name: string, projection = 'select') {
        return this.searchByQuery({[query]: {$eq: true}, name: {$regex: name}}, projection).pipe(map(d => d.data));
    }

    searchByType(type: string, query: EntityQuery, projection = 'select') {
        return this.searchByQuery({'type.label': {$eq: type}, [query]: {$eq: true}}, projection).pipe(map(d => d.data));
    }

    searchByName(name: string, projection = 'select') {
        const q = {name: {$regex: name}};
        return this.searchByQuery(q, projection).pipe(map(d => d.data));
    }

    searchByTypeAndName(type: string, query: EntityQuery, name: string, projection = 'select') {
        const q = {'type.label': {$eq: type}, [query]: {$eq: true}, name: {$regex: name}};
        return this.searchByQuery(q, projection).pipe(map(d => d.data));
    }

    private searchParams(data: IPagedSearch) {
        const {active, direction} = data.sort;
        const {pageIndex, pageSize} = data.page;
        let params = new HttpParams();
        params = params.append('pageIndex', `${pageIndex}`);
        params = params.append('pageSize', `${pageSize}`);
        params = params.append('sort', active);
        params = params.append('order', direction);
        params = params.append('projection', data.projection || 'dataTable');
        return params;
    }

    search(data: IPagedSearch): Observable<IPagedData<IEntityCreated>> {
        const params = this.searchParams(data);
        return this.httpClient.post<IPagedData<IEntityCreated>>(`${ENTITY_URL}/search`, data.condition, {params});
    }

    getOne(id: string): Observable<IEntity> {
        let params = new HttpParams();
        params = params.append('projection', `form`);
        const url = `${ENTITY_URL}/${id}`;
        return this.httpClient.get<IEntity>(url, {params});
    }

    get(data: IPagedSearch): Observable<IPagedData<IEntity>> {
        const params = this.searchParams(data);
        return this.httpClient.get<IPagedData<IEntity>>(ENTITY_URL, {params});
    }

    getDropDown(): Observable<IEntityDropDown> {
        return this.httpClient.get<IEntityDropDown>(ENTITY_URL);
    }
}
